import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RilyLibCalculatorV8Service {

  constructor() { }
}
